module.exports = __webpack_public_path__ + "static/img/l-panl-icon.d9398585.png";